export default "__VITE_ASSET__DWJghJFk__"